import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useCloseToCompetencySection} from './CloseToCompetencySection.hook';
import {CloseToCompetencySectionProps} from './CloseToCompetencySection.types';

export const CloseToCompetencySection = ({
  currentUserCompetency = '',
  executiveDirector = 0,
  fibc = 0,
  seniorCoach = 0,
  onShowInfoPopover = () => {},
  onShowReport = () => {},
}: CloseToCompetencySectionProps) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {listItems, onInfoPress, onItemPress, ts} = useCloseToCompetencySection(
    {
      currentUserCompetency,
      executiveDirector,
      fibc,
      onShowReport,
      seniorCoach,
      onShowInfoPopover,
    },
  );

  return (
    <MetricSection
      analyticsTitle="Close to Competency"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Close to Competency Section Information',
      )}
      testID={MetricsSection.metricSectionCloseToCompetency}
      title={ts('heading', 'Close to Competency')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default CloseToCompetencySection;
